import { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { parseFloatOrZero } from '@/utils/parseFloatOrZero';
import './Slider.scss';

type SliderProps = {
  initialValue: number;
  min?: number;
  max?: number;
  step?: number;
  onChange?: (value: number) => void;
  onSave?: (value: number) => void;
  onBlur?: () => void;
};
export const Slider: FunctionComponent<SliderProps> = ({
  initialValue,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  onSave,
  onBlur,
}) => {
  const [inputValue, setInputValue] = useState(String(initialValue));
  const input = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const inputRef = input.current;
    if (inputRef) {
      inputRef.style.setProperty('--min', String(min));
      inputRef.style.setProperty('--max', String(max));
      inputRef.style.setProperty('--val', String(initialValue));
    }
    setInputValue(String(initialValue));
  }, [min, max, initialValue]);

  const setValue = useCallback(
    (value: number) => {
      if (value < min || value > max || !input.current) {
        return;
      }
      const sValue = String(value);
      input.current.style.setProperty('--val', sValue);
      setInputValue(sValue);
      if (onChange) {
        onChange(value);
      }
    },
    [min, max, onChange]
  );

  const onEndChange = onSave ? () => onSave(parseFloat(inputValue)) : undefined;

  return (
    <input
      className="sprd-slider"
      type="range"
      ref={input}
      min={min}
      max={max}
      step={step}
      value={inputValue}
      onChange={() => setValue(parseFloatOrZero(input.current?.value))}
      onBlur={onBlur}
      onMouseUp={onEndChange}
      onTouchEnd={onEndChange}
      onKeyUp={onEndChange}
    />
  );
};
